/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Col_QuantityInputs */

const vi_warehouse_defects_col_quantity = /** @type {(inputs: Warehouse_Defects_Col_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng lỗi`)
};

/**

* @param {Warehouse_Defects_Col_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_col_quantity = /** @type {((inputs?: Warehouse_Defects_Col_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Col_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_col_quantity(inputs)
});